import React, { FC, ReactNode } from 'react';

import cx from 'classnames';

import { Button, Text } from '@nord/ui';

import img404 from '../../assets/img/404bg.png';
import ErrorBlock from '../../molecules/ErrorBlock';
import List from '../../molecules/List';

interface INotFoundPage {
  buttonText?: ReactNode;
  headingText?: ReactNode;
}

const NotFoundPage: FC<INotFoundPage> = ({
  buttonText = 'Back to Control Panel',
  headingText = 'The page you are looking for can not be found',
}) => (
  <ErrorBlock
    className="bg-white text-grey-darkest"
    outerClassName="headerPad"
    status={
      <Text variant="h1" className="text-huge text-grey-lighter">
        404
      </Text>
    }
    statusWrapClassName="mb-2 pb-4"
    heading={
      <Text variant="h4" className="font-bold">
        {headingText}
      </Text>
    }
    headingWrapClassName="mb-6 lg:mb-2 pb-4"
    background={{
      role: 'img',
      'aria-label': 'Page not found background',
      'xs-image': { src: img404 },
      position: 'center bottom',
      noLazy: true,
    }}
  >
    <Text variant="subtitle2" className="-mb-2">
      Possible reasons:
    </Text>
    <List
      className="mb-5 text-grey-shuttle"
      items={[
        <Text>The link may be broken or outdated</Text>,
        <Text>The address may have been mistyped</Text>,
      ]}
      itemsPadding="pl-4"
    />
    <Button
      href="/"
      component="a"
      color="blue"
      variant="contained"
      className={cx(
        'w-full lg:w-auto min-w-240 max-w-288 block mx-auto lg:mx-none lg:inline-block text-center font-bold'
      )}
    >
      {buttonText}
    </Button>
  </ErrorBlock>
);

export default NotFoundPage;
